import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import {
  ApplicationDetail,
  DegreeOutput,
  FlatList,
  NationalityOutput,
  UserDetail
} from 'types/api'

export const regionsQueryKey = ['applications']

type ApplicationsDetailResponse = {
  application: ApplicationDetail
  user: UserDetail
  flats: FlatList[]
  user_nationality: NationalityOutput | null
  user_degree: DegreeOutput | null
}

export function useApplicationsDetail(id?: string) {
  async function getApplications(): Promise<ApplicationsDetailResponse> {
    const application = await apiClient.get<ApplicationDetail>(
      SNA_PREFIX + `applications/${id}`
    )
    const user = await apiClient.get<UserDetail>(
      SNA_PREFIX + `users/${application.data.user}`
    )

    let user_nationality: NationalityOutput | null = null
    if (user.data.nationality) {
      const nationalityResponse = await apiClient.get<NationalityOutput>(
        SNA_PREFIX + `nationalities/${user.data.nationality}`
      )
      user_nationality = nationalityResponse.data
    }

    let user_degree: DegreeOutput | null = null
    if (user.data.degree) {
      const degreeResponse = await apiClient.get<DegreeOutput>(
        SNA_PREFIX + `degrees/${user.data.degree}/`
      )
      user_degree = degreeResponse.data
    }

    const flats = await apiClient.get<FlatList[]>(SNA_PREFIX + 'flats?limit=-1')

    return {
      application: application.data,
      user: user.data,
      flats: flats.data,
      user_nationality: user_nationality,
      user_degree: user_degree
    }
  }

  return useQuery({
    queryFn: getApplications,
    queryKey: [...regionsQueryKey, id],
    enabled: Boolean(id)
  })
}
